const fixtures = [
  { label: 'Munich, Germany', location: { lat: 48.135, lng: 11.581 }, },
  { label: 'Berlin, Germany', location: { lat: 52.520, lng: 13.404 }, },
  { label: 'Nuremberg, Germany', location: { lat: 49.454, lng: 11.074 }, },
  { label: 'München, Germany', location: { lat: 48.135, lng: 11.581 }, },
  { label: 'Nürnberg, Germany', location: { lat: 49.454, lng: 11.074 }, },
  { label: 'Braunschweig, Germany', location: { lat: 52.267, lng: 10.524 }, },
  { label: 'Hamburg, Germany', location: { lat: 53.548, lng: 9.987 }, },
  { label: 'Germany', location: { lat: 51.165, lng: 10.451 }, },
];

module.exports = fixtures;
